// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2Xek9","selected":"Chip_selected__b3bNc"};